<template>
  <section class="questionnaire-preferences">
    <Breadcrumbs :items="breadcrumbs" />
    <rp-questionnaire-preferences
      v-model="model"
      :questionnaires="questionnaires"
      :surgeonQuestionnaires="surgeonQuestionnaires"
      :oneWeekQuestionnaires="oneWeekQuestionnaires"
      :oneMonthQuestionnaires="oneMonthQuestionnaires"
      @submit="onSubmit"
    />

    <rp-overlay :active="showOverlay">
      <rp-alert
        icon="done"
        message="Your preferences have been updated"
        :onClick="onConfirm" />
    </rp-overlay>

  </section>
</template>

<script>
  import page from '@/mixins/page'
  import Sprite from 'raypro_ui/src/components/ui/Sprite'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert.vue'
  import Button from 'raypro_ui/src/components/ui/inputs/Button'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import QuestionnairePreferences from 'raypro_ui/src/components/ui/forms/QuestionnairePreferences'

  import {mapGetters} from 'vuex'
  import {
    getQuestionnaires,
    getQuestionnairesForSurgeon,
    setQuestionnairesForSurgeon,
    getOneWeekQuestionnaires,
    getOneMonthQuestionnaires
  } from 'raypro_ui/src/api/questionnaire'

  export default {
    mixins: [page],

    components: {
      Breadcrumbs,
      'rp-sprite': Sprite,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      'rp-button': Button,
      'rp-questionnaire-preferences': QuestionnairePreferences,
    },

    data() {
      return {
        model: {},
        questionnaires: [],
        surgeonQuestionnaires: [],
        oneWeekQuestionnaires: [],
        oneMonthQuestionnaires: [],
        showOverlay: false,
        title: 'Questionnaire Preferences',
        breadcrumbs: [{label: 'Questionnaire Preferences'}],
      }
    },

    async mounted() {
      await this.getQuestionnaires()
      await this.getQuestionnairesForSurgeon(this.authUser.id)
      await this.getOneWeekQuestionnaires()
      await this.getOneMonthQuestionnaires()
    },

    computed: {
      ...mapGetters(['authUser']),
    },

    methods: {
      async getQuestionnaires() {
        const data = await getQuestionnaires()
        this.questionnaires = data.data
      },

      async getOneWeekQuestionnaires() {
        const data = await getOneWeekQuestionnaires()
        this.oneWeekQuestionnaires = data.data
      },

      async getOneMonthQuestionnaires() {
        const data = await getOneMonthQuestionnaires()
        this.oneMonthQuestionnaires = data.data
      },

      async getQuestionnairesForSurgeon(surgeon_id) {
        const data = await getQuestionnairesForSurgeon(surgeon_id)
        this.surgeonQuestionnaires = data.data
      },

      async onSubmit(questionnaireIds) {
        const data = {questionnaire_ids: questionnaireIds}
        await setQuestionnairesForSurgeon(this.authUser.id, data)
        this.showOverlay = true
      },

      onConfirm() {
        this.getQuestionnairesForSurgeon(this.authUser.id)
        this.showOverlay = false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'

  .questionnaire-preferences
    font-weight: bold
    font-family: 'Stolzl'
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/QuestionnairePreferences.vue